import cn from 'classnames';
import styles from './ControlledInput.module.scss';
import { ChangeEvent } from 'react';
import { SearchIcon } from '../Icons';

type ControlledInputProps = {
  className?: string;
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
};

export function ControlledInput({
  className,
  value,
  onChange,
  placeholder,
}: ControlledInputProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  return (
    <div className={wrapperClassName}>
      <SearchIcon size={16} color="#00000066" />
      <input
        type="text"
        value={value}
        onChange={onChange}
        className={styles.input}
        placeholder={placeholder}
      />
    </div>
  );
}
